import { __decorate, __metadata } from 'tslib';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCAcceptContentEcComponent = class UiCAcceptContentEcComponent {
    constructor() {
        this.onChange = new EventEmitter();
        this.gotoLink = new EventEmitter();
        this.contractCheckBox = new EventEmitter();
    }
    ngOnInit() { }
    goTo() { this.gotoLink.emit(); }
    acceptContract(event) { this.contractCheckBox.emit(event); }
    onChangeForm() { this.onChange.emit(this.contractEcForm); }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAcceptContentEcComponent.prototype, "accept", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAcceptContentEcComponent.prototype, "ionCheckbox", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCAcceptContentEcComponent.prototype, "contractEcForm", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentEcComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentEcComponent.prototype, "gotoLink", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAcceptContentEcComponent.prototype, "contractCheckBox", void 0);
UiCAcceptContentEcComponent = __decorate([
    Component({
        selector: 'ui-c-accept-content-ec',
        template: "<ion-text class=\"accept-content\">\n  <ng-content></ng-content>\n</ion-text>\n\n<ng-container *ngIf=\"!!accept\">\n  <form [formGroup]=\"contractEcForm\" (change)=\"onChangeForm()\">\n    <ion-row>\n      <ion-col class=\"checkbox-container ion-no-padding\">\n        <ion-checkbox class=\"ion-checkbox\" mode=\"ios\" formControlName=\"acceptContract\"\n          (ionChange)=\"acceptContract($event)\">\n        </ion-checkbox>\n        <ion-text class=\"ion-text\">\n          <p>\n            {{ 'ONBOARDING_EC.CONTRACT.CONTRACT_ACCEPTION_FLAG' | wlpTranslate }}\n            <span class=\"font-weight-bold\" (click)=\"goTo()\">\n              {{ 'ONBOARDING_EC.CONTRACT.PRIVACY_POLICY' | wlpTranslate }}.\n            </span>\n          </p>\n        </ion-text>\n      </ion-col>\n    </ion-row>\n  </form>\n</ng-container>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCAcceptContentEcComponent);

let UiCAcceptContentEcModule = class UiCAcceptContentEcModule {
};
UiCAcceptContentEcModule = __decorate([
    NgModule({
        declarations: [UiCAcceptContentEcComponent],
        imports: [
            IonicModule,
            ReactiveFormsModule,
            CommonModule,
            UiBsTranslateModule
        ],
        exports: [UiCAcceptContentEcComponent]
    })
], UiCAcceptContentEcModule);

export { UiCAcceptContentEcComponent, UiCAcceptContentEcModule };
//# sourceMappingURL=wlp-ui-c-accept-content-ec.js.map
